import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Icon from "./Icon";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { getEnv } from "../../environment";
import "./css/Header.css";
import toast from "react-hot-toast";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const env = getEnv();

export default function Header() {
  let navigate = useNavigate();
  let location = useLocation();
  const currentPath = location.pathname;
  const [hbMenuState, setHbMenuState] = useState(false);

  // Get data for current user
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const activeAccount = instance.getActiveAccount();
  const roles = activeAccount?.idTokenClaims.roles || [];
  const isAdmin = roles.includes("cvp.write");

  // Clear all notifications on navigate
  useEffect(() => {
    toast.dismiss();
  }, [location.key]);

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: [env.auth_scope],
    });
  };

  return (
    <>
      <header className="header-container">
        <span style={{ width: "100%", display: "flex" }}>
          <div className="header-gm-logo">
            <img
              src="/resources/gm-logo-long.png"
              alt="GM Logo"
              style={{ height: "21px", width: "166px" }}
            />
          </div>
          {!isAuthenticated ? (
            <button onClick={() => handleLogin()}>Login</button>
          ) : null}
        </span>
        <nav className="blue-gm-navbar">
          <div className="nav-list-container">
            <ul role="menubar" className="navbar-parent-list nav-list">
              <ul className="left-nav-list nav-list">
                <li className="m-0">
                  <div
                    role="menuitem"
                    tabIndex="0"
                    onClick={() => {
                      navigate("/");
                      window.location.reload();
                    }}
                    className="navbar-list-title navbar-list-text nav-list-item"
                  >
                    <span>Circuit Vault Portal</span>
                  </div>
                </li>
                {isAuthenticated ? (
                  <>
                    <li className="m-0">
                      <div
                        role="menuitem"
                        tabIndex="0"
                        onClick={() => navigate("/")}
                        className={`navbar-list-text nav-list-item mobile-hide ${
                          currentPath === "/" ? "active-nav-item" : ""
                        }`}
                      >
                        <span>Sites & Circuits</span>
                      </div>
                    </li>

                    <li className="m-0">
                      <div
                        role="menuitem"
                        tabIndex="0"
                        onClick={() => navigate("/carrier")}
                        className={`navbar-list-text nav-list-item mobile-hide ${
                          currentPath.includes("/carrier")
                            ? "active-nav-item"
                            : ""
                        }`}
                      >
                        <span>Carriers</span>
                      </div>
                    </li>
                    {isAdmin && (
                      <li className="m-0">
                        <div
                          role="menuitem"
                          tabIndex="0"
                          onClick={() => navigate("/reference")}
                          className={`navbar-list-text nav-list-item mobile-hide ${
                            currentPath === "/reference"
                              ? "active-nav-item"
                              : ""
                          }`}
                        >
                          <span>Reference Tables</span>
                        </div>
                      </li>
                    )}
                  </>
                ) : null}
              </ul>

              {/* Right-aligned help icon */}
              <ul className="right-nav-list nav-list">
                <li className="m-0">
                  {/* Link to Net Viz */}
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="net-viz-tooltip">
                        Open Net Viz
                      </Tooltip>
                    }
                  >
                    <div
                      onClick={() =>
                        window.open("https://wanmaps.gm.com/", "_blank")
                      }
                      className="navbar-list-text nav-list-item"
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <span>NetViz</span>
                    </div>
                  </OverlayTrigger>
                </li>
                <li className="m-0">
                  <Icon
                    name="question"
                    onClick={() =>
                      window.open(
                        "https://gm-sdv.atlassian.net/wiki/spaces/IT/pages/598255458/Circuit+Vault+Portal+User+Guide",
                        "_blank",
                      )
                    }
                    overrides={{
                      tooltip: "User Guide",
                      tooltipPlacement: "bottom",
                      size: "1.55rem",
                      style: {
                        marginRight: "10px",
                      },
                    }}
                    id="help-icon"
                  />
                </li>
                {/* Admin Cog */}
                {isAdmin && (
                  <li className="m-0">
                    <Icon
                      name="admin"
                      onClick={() => window.open("/audit", "_blank")}
                      overrides={{
                        tooltip: "Audit Page",
                        tooltipPlacement: "bottom",
                        iconColor: "#FFFFFF",
                      }}
                      id="admin-icon"
                    />
                  </li>
                )}
              </ul>
            </ul>
          </div>
        </nav>
      </header>
      {/* Slide out panel on mobile */}
      <Offcanvas
        className="hamburger-canvas"
        style={{ width: "200px", height: "100%" }}
        show={hbMenuState}
        onHide={() => setHbMenuState(false)}
        backdrop={false}
        scroll={true}
        placement="end"
      >
        <Offcanvas.Body
          style={{ marginTop: "80px", backgroundColor: "var(--wm-main-blue)" }}
        >
          <ul
            className="nav-list"
            style={{
              overflow: "hidden",
              marginRight: "auto",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <li style={{ width: "100%", margin: 0 }}>
              <div
                className="navbar-list-text nav-list-item"
                onClick={() => {
                  setHbMenuState(false);
                  navigate("/");
                }}
                style={{
                  fontSize: "0.875rem",
                  padding: "0.25rem 0.5rem",
                  fontFamily: "Arial,sans-serif",
                  borderBottom: "1px solid white",
                }}
              >
                <span>Sites & Circuits</span>
              </div>
            </li>
            <li style={{ width: "100%", margin: 0 }}>
              <div
                className="navbar-list-text nav-list-item"
                onClick={() => {
                  setHbMenuState(false);
                  navigate("/carriers");
                }}
                style={{
                  fontSize: "0.875rem",
                  padding: "0.25rem 0.5rem",
                  fontFamily: "Arial,sans-serif",
                  borderBottom: "1px solid white",
                }}
              >
                <span>Supplier</span>
              </div>
            </li>
            <li style={{ width: "100%", margin: 0 }}>
              <div
                className="navbar-list-text nav-list-item"
                onClick={() => {
                  setHbMenuState(false);
                  navigate("/supplier");
                }}
                style={{
                  fontSize: "0.875rem",
                  padding: "0.25rem 0.5rem",
                  fontFamily: "Arial,sans-serif",
                  borderBottom: "1px solid white",
                }}
              >
                <span>Reference Tables</span>
              </div>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
